export default function (state = {
    isItineraryShown: false,
    isDashboardShown: false,
    isExpiredTab: false,

}, action) {
    switch (action.type) {
        case 'SET_IS_ITINERARY_SHOWN':
            return {...state, isItineraryShown: action.isItineraryShown};

        case 'SET_IS_DASHBOARD_SHOWN':
            return {...state, isDashboardShown: action.isDashboardShown};

        case 'SET_IS_EXPIRED_TAB':
            return {...state, isExpiredTab: action.isExpiredTab};
        default:
            return state;
    }
}